export default {
  siteName: '黑料吃瓜',
  siteTagline: '24小时不打烊，全网黑料独家首发',
  navHome: '首页',
  navWanghong: '网红反差',
  navMingxing: '明星塌房',
  navDasai: '每日大赛',
  navDujia: '独家首发',
  navAbout: '关于我们',
  heroTitle1: '24小时不打烊',
  heroTitle2: '全网黑料吃瓜',
  heroSubtitle: '实时更新全网最新爆料，每日大赛精彩不停歇',
  heroCta: '立即围观',
  categoriesLabel: '精选频道',
  categoriesTitle: '网红反差爆料 / 明星塌房内幕',
  trendingTitle: '🔥 全网热点',
  trendingSubtitle: '24小时滚动更新',
  dailyTitle: '每日大赛不停歇',
  dailyDesc1: '汇聚全网最劲爆爆料，每日评选最佳瓜料。',
  dailyDesc2: '参与互动，一起围观娱乐圈的千姿百态。',
  dailyCta: '立即围观',
  exclusiveLabel: '独家首发',
  exclusiveQuote: '我们只呈现经过核实的第一手爆料，每一份独家资料背后都有专业团队的深度追踪。',
  exclusiveAuthor: '黑料吃瓜编辑部',
  footerBrand: '黑料吃瓜',
  footerDesc1: '24小时不打烊的娱乐爆料平台',
  footerDesc2: '全网首发，独家追踪',
  footerDesc3: '让真相无所遁形',
  footerNewsletter: '订阅爆料快讯',
  footerNewsletterPlaceholder: '输入邮箱地址',
  footerNewsletterTip: '订阅即可第一时间获取最新爆料',
  footerLinks: '快速链接',
  footerSocial: '关注我们',
  footerCopyright: '© 2026 黑料吃瓜 版权所有',
  breadcrumbHome: '首页',
  articleRelated: '相关推荐',
  articleAuthor: '作者',
  articleViews: '阅读',
  articlePublished: '发布于',
  aboutMissionLabel: '关于黑料吃瓜',
  aboutMissionTitle: '品牌使命与平台信誉',
  aboutMissionText: '黑料吃瓜网成立于2026年，是一个专注于娱乐爆料资讯的中文内容平台。我们致力于为用户提供最新、最热的全网黑料吃瓜视频与每日大赛现场内容。平台以"24小时不打烊，独家首发"为定位，汇聚专业调查团队，对娱乐圈、网红圈的热点事件进行深度追踪与核实。我们坚持信息真实、来源可靠、呈现客观的原则，努力打造一个值得信赖的娱乐资讯聚合平台。在信息爆炸的时代，我们希望为用户筛选出最有价值的爆料内容，让每一份独家资料都经得起推敲。',
  aboutFeaturesLabel: '核心优势',
  aboutFeaturesTitle: '全网监控 / 即时首发',
  aboutFeature1Title: '全网实时监控',
  aboutFeature1Desc: '7×24小时不间断扫描全网娱乐动态，第一时间捕捉热点事件',
  aboutFeature2Title: '独家首发爆料',
  aboutFeature2Desc: '专业团队深度追踪，第一手资料独家呈现，拒绝二手传播',
  aboutFeature3Title: '真实可靠来源',
  aboutFeature3Desc: '严格核实信息来源，确保爆料真实可信，对虚假内容零容忍',
  aboutFounderQuote: '我们致力于打造一个透明、公正的娱乐资讯平台，让每一个关注娱乐圈的人都能第一时间了解真相。',
  aboutFounderName: '创始人 · 张黑料',
  aboutContactTitle: '联系我们',
  aboutContactEmail: '联系邮箱',
  aboutContactWechat: '微信公众号',
  aboutContactWeibo: '官方微博',
  notFoundTitle: '页面不存在',
  notFoundDesc: '您访问的页面可能已经删除或移动，返回首页继续吃瓜吧',
  notFoundCta: '返回首页',
  readMore: '阅读全文',
  loadMore: '加载更多',
  hotTag: '热',
  exclusiveTag: '独家',
  newTag: '新',
};